export const Div = ({content}) => {
    return (
            <div dangerouslySetInnerHTML={{__html: content}} />
            );
};

export const Space = () => {
    return (
            <span dangerouslySetInnerHTML={{__html: '&nbsp;'}} />
            );
};
